import api from './../utils/api';


export const createNewEmailForAdmin = async () => {
  try {
    const response = await api.post(`/gmail/create`,
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getEmailsByAlias = async (alias) => {
  try {
    const response = await api.get(`/gmail/get-emails/${alias}`,
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllEmailsForAdmin = async (limit, page, search = "") => {
  try {
    const query = encodeURIComponent(search);
    const response = await api.get(`/gmail/all-emails?limit=${limit}&page=${page}&search=${query}`,
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteEmailForAdmin = async (emailId) => {
  try {
    const response = await api.delete(`/gmail/delete/${emailId}`,
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getOtpCode = async (email, password) => {
  try {
    const response = await api.post(`/gmail/get-otp`,
      {
        email,
        password
    },
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};